/**
 * Theme AJAX add-to-cart (nuranium.js) calls preventDefault on the ATC button click,
 * so native form submission — and HTML5 constraint validation — never runs.
 * Validate in capture phase before that handler. For the sticky bar, required line item
 * properties are associated with the main #product-form-{section}, not #product-form-sticky-*.
 */
(function () {
  'use strict';

  function resolveCartAddFormForButton(button) {
    const innerForm = button.closest('form');
    if (!innerForm) return null;
    const action = innerForm.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return null;

    const sid = innerForm.getAttribute('data-section');
    const fid = innerForm.getAttribute('id') || '';
    if (sid && fid.indexOf('product-form-sticky-') === 0) {
      const main = document.getElementById('product-form-' + sid);
      if (main) return main;
    }
    return innerForm;
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn =
        e.target &&
        e.target.closest &&
        e.target.closest('button[type="submit"][name="add"].product-form__cart-submit');
      if (!btn || btn.disabled) return;

      const formToCheck = resolveCartAddFormForButton(btn);
      if (!formToCheck || typeof formToCheck.checkValidity !== 'function') return;

      if (!formToCheck.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        formToCheck.reportValidity();
      }
    },
    true
  );
})();
